import { GetterTree } from 'vuex';
import { IDealroomViewState } from '@/dealroom-view/store/dealroom-view.store';
import { RootState } from '@/store/store';
import { IField } from '@/fields/types/field';
import { calculateFieldPositionForPlacement } from '@/fields/helpers/field-placement.helper';
import { IDocumentPage } from '@/types/document-page';
import { EDocumentPageType } from '@/enums/document-page-type';

export const getterPositionedFields = 'positionedFields';
export const getterOnlyDocumentContentPages: string = 'onlyDocumentContentPages';

export const getters: GetterTree<IDealroomViewState, RootState> = {
  [getterPositionedFields](state: IDealroomViewState): IField[] {
    return state.fields.map((field: IField) => ({
      ...field,
      position: calculateFieldPositionForPlacement(field.position, state.pageWidth),
    }));
  },
  [getterOnlyDocumentContentPages](state: IDealroomViewState): boolean {
    if (!state.document?.pages?.length) {
      return true;
    }
    return state.document.pages.every(
      (page: IDocumentPage) => page.pageType === EDocumentPageType.DocumentContent
    );
  },
};
